import React from 'react';
import { CheckIcon } from 'lucide-react';
import type { ServiceCoverageItem } from '../../types/servicePage';
type ServiceCoverageProps = {
  name: string;
  intro?: string;
  items: ServiceCoverageItem[];
};
export function ServiceCoverage({
  name,
  intro,
  items
}: ServiceCoverageProps) {
  return <section className="bg-white py-20 lg:py-24" data-id="element-349" data-mp="xpm6pze0kx3d">
      <div className="mx-auto max-w-7xl px-5 lg:px-8" data-id="element-350" data-mp="xob78brlqbi2">
        <div className="flex flex-col justify-between gap-6 lg:flex-row lg:items-end" data-id="element-351" data-mp="zlnefwez8tg">
          <h2 className="max-w-2xl font-display text-4xl font-extrabold uppercase leading-[0.95] text-ink sm:text-5xl" data-id="element-352" data-mp="5xesf5lzdws5">
            {name}: <span className="text-brand" data-id="element-353" data-mp="9yqljl42d053">what’s covered</span>
          </h2>
          {intro && <p className="max-w-md text-lg leading-relaxed text-ink-muted" data-id="element-354" data-mp="ezo07npv7c1u">{intro}</p>}
        </div>
        <ul className="mt-12 grid border-t border-line sm:grid-cols-2 sm:gap-x-10 lg:grid-cols-3" data-id="element-355" data-mp="1ldnakv08zpcg">
          {items.map(item => <li key={item.title} className="flex gap-4 border-b border-line py-6" data-id="element-356" data-mp="1qbx8veh9r62a">
              <span className="grid h-8 w-8 shrink-0 place-items-center rounded-full bg-brand-light text-brand" data-id="element-357" data-mp="1bl12qss6h6ds">
                <CheckIcon className="h-4 w-4" strokeWidth={3} aria-hidden="true" data-id="element-358" data-mp="16n7w5ymyqacz" />
              </span>
              <div data-id="element-359" data-mp="11pg7ddhm74d0">
                <h3 className="font-display text-2xl font-bold leading-tight text-ink" data-id="element-360" data-mp="woaenfnyfh3h">{item.title}</h3>
                <p className="mt-1 text-[15px] leading-relaxed text-ink-muted" data-id="element-361" data-mp="smovxdoqo8ld">{item.text}</p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}